'use client'

import {useTranslate} from '@local/hooks'

interface LocaleProps {
	children: string
}

export const Locale = ({children}: LocaleProps) => {
	const locale = useTranslate()

	return (
		<>
			{locale(children)}
		</>
	)
}
